"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteTemplateRequestSchema = exports.AddTemplateResponseSchema = exports.AddTemplateRequestSchema = exports.GetDocumentByIdSchema = exports.GetFormResponseSchema = void 0;
const zod_1 = require("zod");
const consignment_1 = require("../misc/consignment");
exports.GetFormResponseSchema = zod_1.z.object({
    docId: zod_1.z.string(),
    formType: consignment_1.FormTypeSchema,
    details: zod_1.z.object({
        name: zod_1.z.string(),
        answers: zod_1.z.array(consignment_1.FormAnswerSchema)
    })
});
exports.GetDocumentByIdSchema = zod_1.z.object({
    docId: zod_1.z.string(),
    type: zod_1.z.literal("template"),
    formType: consignment_1.FormTypeSchema.optional(),
    details: zod_1.z.object({
        name: zod_1.z.string(),
        answers: zod_1.z.array(consignment_1.FormAnswerSchema)
    })
});
exports.AddTemplateRequestSchema = zod_1.z.object({
    type: zod_1.z.literal("template"),
    name: zod_1.z.string(),
    formType: consignment_1.FormTypeSchema,
    answers: zod_1.z.array(consignment_1.FormAnswerSchema)
});
exports.AddTemplateResponseSchema = zod_1.z.object({
    docId: zod_1.z.string(),
    type: zod_1.z.literal("template"),
    userId: zod_1.z.string(),
    businessId: zod_1.z.string(),
    formType: consignment_1.FormTypeSchema,
    details: zod_1.z.object({
        name: zod_1.z.string(),
        answers: zod_1.z.array(consignment_1.FormAnswerSchema)
    })
});
exports.DeleteTemplateRequestSchema = zod_1.z.object({
    docId: zod_1.z.string(),
    type: zod_1.z.string()
});
